/**
 * 提示格式管理类，负责管理不同模型的输出格式定义
 */
export class PromptFormat {
  /**
   * 获取标准JSON输出格式定义
   * @returns JSON格式定义字符串
   */
  static getStandardJsonFormat(): string {
    return `你必须以严格的JSON格式输出响应，不要输出任何其他内容，格式如下：

\`\`\`json
{
    "scene_text": "场景的详细描述，包括环境、氛围和当前情况",
    "npc_dialogue": "当前场景中NPC的对话内容（如果有）该字段不使用 json 结构，使用纯文本",
    "choices": [
        {
            "text": "玩家可以选择的行动，必须是符合当前场景的行动，体现主动性。不能是继续之类的没有意义的、脱离游戏设定的选项。",
            "next_scene": "选择后进入的场景ID",
            "requirements": "选择这个选项需要满足的条件（null表示无条件）"
        },
        // 更多选项...
    ],
    "state_changes": {
        "inventory": ["玩家最新的物品列表"],
        "flags": {"事件标记": true/false},
        "relationships": {"NPC名称": 关系值}
    }
}
\`\`\`

确保始终遵循这个格式，你的输出必须是有效的JSON。不要输出任何解释或额外文本，只输出JSON。`;
  }

  /**
   * 获取格式说明
   * @returns 格式定义字符串
   */
  static getFormat(): string {
    return this.getStandardJsonFormat();
  }
} 